import React from 'react';
import {useSelector} from 'react-redux';
import {Card} from '~/common/canvas/Card/Card';
import {selectFabricArt} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {useLiners} from '~/common/fabric/CreateDesign/components/Envelope/actions/useLiner';
import {Envelope as EnvelopeImage} from '~/common/fabric/Card/components/Envelope/Envelope';
import {largishAndUp} from '~libSass/base/_exports.sass';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {Sections} from '~/common/fabric/CreateDesign/constants';

export const Envelope = () => {
  const {selectedLiner} = useLiners();
  const fabricArt = useSelector(selectFabricArt);
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);

  return (
    <div className="envelope">
      <div className="envelope__images">
        <Card
          className="envelope__images__card"
          fabricArt={fabricArt}
          redirectTo={isDesktop ? Sections.CARD_DESIGN : null}
        />
        <EnvelopeImage
          type="blank"
          className="envelope__images__envelope"
          selectedLiner={selectedLiner?.image}
        />
      </div>
    </div>
  );
};
